import requestCommon from "@/components/web-interface/requestCommon";
const state = {
  variableDetails: null
};
const actions = {
  getVariableDetails(context, data) {
    return requestCommon.getInfo(
      "/system/variable",
      data,
      null,
      context,
      "getVariableDetailsSuccessHandler",
      "getVariableDetailsErrorHandler"
    );
  },
  updateVariables(context, data) {
    return requestCommon.patchInfo(
      "/system/variable",
      null,
      data,
      context,
      "updateVariablesSuccessHandler",
      "updateVariablesErrorHandler",
    );
  },
}
const mutations = {
  getVariableDetailsSuccessHandler(state, data) {
    state.variableDetails = data.server.data;
  },
  getVariableDetailsErrorHandler(context, error) {
    console.log(error);
  },
  updateVariablesSuccessHandler(state, data) {
    console.log('update data:', data);
  },
  updateVariablesErrorHandler(context, error) {
    console.log(error);
  }
};
const getters = {};
export const variableStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}